import { DeleteButton, usePermissions } from 'react-admin'
import React from 'react'

const VisitDeleteButton = (props) => {
  const { record } = props

  const { permissions } = usePermissions()

  if (record.status !== 'deleted') {
    return <DeleteButton {...props} disabled={!permissions?.inspection.canDelete(record)} />
  } else {
    return null
  }
}

export default VisitDeleteButton
